const initialState = {
    loading: false,
    error: null,
    message: null,
    webinarList: null,
    webinar: null,
    webinar_speakers: null,
    webinar_url: null,
    webinar_synonym: null,
    webinar_synonym_list: null,
    post_webinar_speakers: null,
    put_webinar_speaker: null,
    delete_webinar_speaker: null,
    put_webinar_url: null,
    post_webinar_url: null,
    put_webinar_url_error: null,
    delete_webinar_url: null,
    delete_webinar_url_error: null,
    postWebinarResponse: null,
    postWebinarResponseError: null,
    postWebinarSpeakersResponseError: null,
    postWebinarUrlResponseError: null,
    putWebinarResponse: null,
    putWebinarResponseError: null,
    post_webinar_synonym: null,
    autoSearchWebinarListLoading: null,
    autoSearchWebinarList: null,
    autoSearchWebinarListError: null,
    delete_keyword_reponse: null,
    delete_keyword_error: null,
    spgData: null,
    spgDataError: null,
    entityTypeListloading: null,
    entityTypeList: null,
    entityTypeListError: null,
    entityNameListloading: null,
    entityNameList: null,
    entityNameListError: null,
    entityMainCategoryListloading: null,
    entityMainCategoryList: null,
    entityMainCategoryListError: null,
    entitySubCategoryListloading: null,
    entitySubCategoryList: null,
    entitySubCategoryListError: null,
    agendaDataloading: null,
    agendaData: null,
    agendaDataError: null,
    faqDataloading: null,
    faqData: null,
    faqDataError: null,
    putWebinarKeywordMapping: null,
    putWebinarKeywordMappingError: null,
    putWebinarAgenda: null,
    putWebinarAgendaError: null,
    putWebinarFaq: null,
    putWebinarFaqError: null,
    keywordMappingDataloading: null,
    keywordMappingData: null,
    keywordMappingDataError: null
}

const WebinarReducer = (state = initialState, action) => {
    // console.log(action, "action 1")
    switch (action.type) {
        case 'GET_CMS_WEBINAR_LIST_REQUEST':
            return {
                ...state,
                loading: true,
            }
        case 'GET_CMS_WEBINAR_LIST_SUCCESS':
            return {
                ...state,
                loading: false,
                webinarList: action.payload,
            }
        case 'GET_CMS_AUTO_SEARCH_WEBINAR_LIST_REQUEST':
            return {
                ...state,
                autoSearchWebinarListLoading: true,
            }
        case 'GET_CMS_AUTO_SEARCH_WEBINAR_LIST_SUCCESS':
            return {
                ...state,
                autoSearchWebinarListLoading: false,
                autoSearchWebinarList: action.payload
            }
        case 'GET_CMS_AUTO_SEARCH_WEBINAR_LIST_FAILURE':
            return {
                ...state,
                autoSearchWebinarListLoading: false,
                autoSearchWebinarListError: action.payload
            }

        case 'GET_CMS_WEBINAR_LIST_FAILURE':
            return {
                ...state,
                loading: false,
                error: action.payload,
            }
        case 'POST_CMS_WEBINAR_SUCCESS':
            return {
                ...state,
                message: 'Webinar Added Successfully',
                error: false,
                postWebinarResponse: action.payload
            }
        case 'POST_CMS_WEBINAR_FAILURE':
            return {
                ...state,
                message: 'Webinar Errors',
                error: true,
                postWebinarResponseError: action.payload
            }

        case 'PUT_CMS_WEBINAR_SUCCESS':
            return {
                ...state,
                message: 'Webinar Added Successfully',
                error: false,
                putWebinarResponse: action.payload
            }
        case 'PUT_CMS_WEBINAR_FAILURE':
            return {
                ...state,
                message: 'Webinar Errors',
                error: true,
                putWebinarResponseError: action.payload
            }
        case 'CLEAR_WEBINAR_DETAIL_RESPONSE':
            return {
                ...state,
                message: null,
                error: null,
                putWebinarResponse: null,
                putWebinarResponseError: null,
            }
        case 'CLEAR_WEBINAR_RESPONSE':
            return {
                ...state,
                message: null,
                error: null,
                postWebinarResponse: null,
                putWebinarResponse: null,
                postWebinarResponseError: null,
                putWebinarResponseError: null,
                putWebinarKeywordMapping: null,
                putWebinarKeywordMappingError: null,
                faqData: null,
                faqDataError: null,
                agendaData: null,
                agendaDataError: null,
                spgDataError: null,
                spgData: null,
                webinar_speakers: null,
                postWebinarSpeakersResponseError: null,
                post_webinar_url: null,
                postWebinarUrlResponseError: null,
                post_webinar_speakers: null,
                post_webinar_url: null,
                putWebinarAgenda: null,
                putWebinarAgendaError: null,
                putWebinarFaq: null,
                putWebinarFaqError: null
            }
        case 'GET_CMS_WEBINAR_REQUEST':
            return {
                ...state,
                loading: true,
            }
        case 'GET_CMS_WEBINAR_SUCCESS':
            return {
                ...state,
                loading: false,
                webinar: action.payload
            }
        case 'GET_CMS_WEBINAR_FAILURE':
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        case 'CLEAR_WEBINAR':
            return {
                ...state,
                webinar: null
            }
        case 'GET_CMS_WEBINAR_SPEAKERS_SUCCESS':
            return {
                ...state,
                webinar_speakers: action.payload,
                loading: false
            }
        case 'GET_CMS_WEBINAR_SPEAKERS_FAILURE':
            return {
                ...state,
                error: action.payload,
                loading: false
            }
        case 'GET_CMS_WEBINAR_SPEAKERS_REQUEST':
            return {
                ...state,
                loading: true
            }
        case 'CLEAR_WEBINAR_SPEAKERS':
            return {
                ...state,
                webinar_speakers: null,
                post_webinar_speakers: null,
                put_webinar_speaker: null,
            }

        // case 'GET_CMS_WEBINAR_URL_SUCCESS':
        //     return {
        //         ...state,
        //         webinar_url: action.payload,
        //         loading: false
        //     }
        case 'GET_CMS_WEBINAR_URL_FAILURE':
            return {
                ...state,
                error: action.payload,
                loading: false

            }
        case 'GET_CMS_WEBINAR_URL_REQUEST':
            return {
                ...state,
                loading: true
            }

        case 'CLEAR_WEBINAR_URL':
            return {
                ...state,
                webinar_url: null,
                post_webinar_url: null,
                put_webinar_url: null,
            }

        // case 'POST_CMS_WEBINAR_URL_SUCCESS':
        //     console.log(action.payload, "......action.payload 1")
        //     return {
        //         ...state,
        //         webinar_url: action.payload
        //     }
        case 'POST_CMS_WEBINAR_URL_FAILURE':
            return {
                ...state,
                postWebinarUrlResponseError: action.payload
            }

        case 'GET_CMS_WEBINAR_SYNONYM_REQUEST':
            return {
                ...state,
                loading: true
            }
        case 'GET_CMS_WEBINAR_SYNONYM_SUCCESS':
            return {
                ...state,
                webinar_synonym: action.payload,
                loading: false
            }
        case 'GET_CMS_WEBINAR_SYNONYM_FAILURE':
            return {
                ...state,
                error: action.payload,
                loading: false
            }

        case 'GET_CMS_SYNONYMS_LIST_SUCCESS':
            return {
                ...state,
                webinar_synonym_list: action.payload,

            }
        case 'GET_CMS_SYNONYMS_LIST_FAILURE':
            return {
                ...state,
                error: action.payload
            }
        case 'CLEAR_WEBINAR_SYNONYM':
            return {
                ...state,
                webinar_synonym: null,
            }
        case 'POST_CMS_WEBINAR_SYNONYM_SUCCESS':
            return {
                ...state,
                post_webinar_synonym: action.payload
            }
        case 'POST_CMS_WEBINAR_SYNONYM_FAILURE':
            return {
                ...state,
                error: action.payload
            }
        case 'POST_CMS_WEBINAR_SPEAKER_SUCCESS':
            return {
                ...state,
                post_webinar_speakers: action.payload
            }
        case 'POST_CMS_WEBINAR_SPEAKER_FAILURE':
            return {
                ...state,
                post_webinar_speakers: null,
                postWebinarSpeakersResponseError: action.payload
            }

        case 'PUT_CMS_WEBINAR_SPEAKER_SUCCESS':
            return {
                ...state,
                put_webinar_speaker: action.payload
            }
        case 'PUT_CMS_WEBINAR_SPEAKER_FAILURE':
            return {
                ...state,
                put_webinar_speaker_error: action.payload
            }

        case 'DELETE_CMS_WEBINAR_SPEAKER_SUCCESS':
            return {
                ...state,
                delete_webinar_speaker: action.payload
            }
        case 'DELETE_CMS_WEBINAR_SPEAKER_FAILURE':
            return {
                ...state,
                delete_webinar_speaker_error: action.payload
            }

        case 'POST_CMS_WEBINAR_URL_SUCCESS':
            console.log(action.payload, "......action.payload 1")
            return {
                ...state,
                post_webinar_url: action.payload
            }
        case 'POST_CMS_WEBINAR_URL_FAILURE':
            return {
                ...state,
                postWebinarUrlResponseError: action.payload
            }

        case 'PUT_CMS_WEBINAR_URL_SUCCESS':
            return {
                ...state,
                put_webinar_url: action.payload
            }
        case 'PUT_CMS_WEBINAR_URL_FAILURE':
            return {
                ...state,
                put_webinar_url_error: action.payload
            }

        case 'DELETE_CMS_WEBINAR_URL_SUCCESS':
            return {
                ...state,
                delete_webinar_url: action.payload
            }
        case 'DELETE_CMS_WEBINAR_URL_FAILURE':
            return {
                ...state,
                delete_webinar_url_error: action.payload
            }
        case "DELETE_CMS_WEBINAR_KEYWORDS_SUCCESS":
            return {
                ...state,
                delete_keyword_reponse: action.payload
            }
        case "DELETE_CMS_WEBINAR_KEYWORDS_FAILURE":
            return {
                ...state,
                delete_keyword_error: action.payload
            }
        case 'GET_CMS_WEBINAR_SGP_DATA_REQUEST':
            return {
                ...state,
                spgDataloading: true,
            }
        case 'GET_CMS_WEBINAR_SGP_DATA_SUCCESS':
            return {
                ...state,
                spgDataloading: false,
                spgData: action.payload
            }
        case 'GET_CMS_WEBINAR_SGP_DATA_FAILURE':
            return {
                ...state,
                loading: false,
                spgDataError: action.payload
            }
        case 'CLEAR_CMS_WEBINAR_SGP_DATA':
            return {
                ...state,
                spgData: null
            }
        case 'GET_CMS_WEBINAR_ENTITY_TYPE_LIST_REQUEST':
            return {
                ...state,
                entityTypeListloading: true,
            }
        case 'GET_CMS_WEBINAR_ENTITY_TYPE_LIST_SUCCESS':
            return {
                ...state,
                entityTypeListloading: false,
                entityTypeList: action.payload
            }
        case 'GET_CMS_WEBINAR_ENTITY_TYPE_LIST_FAILURE':
            return {
                ...state,
                loading: false,
                entityTypeListError: action.payload
            }
        case 'CLEAR_CMS_WEBINAR_ENTITY_TYPE_LIST':
            return {
                ...state,
                entityTypeList: null
            }
        case 'GET_CMS_WEBINAR_ENTITY_NAME_LIST_REQUEST':
            return {
                ...state,
                entityNameListloading: true,
            }
        case 'GET_CMS_WEBINAR_ENTITY_NAME_LIST_SUCCESS':
            return {
                ...state,
                entityNameListloading: false,
                entityNameList: action.payload
            }
        case 'GET_CMS_WEBINAR_ENTITY_NAME_LIST_FAILURE':
            return {
                ...state,
                loading: false,
                entityNameListError: action.payload
            }
        case 'CLEAR_CMS_WEBINAR_ENTITY_NAME_LIST':
            return {
                ...state,
                entityNameList: null
            }
        case 'GET_CMS_WEBINAR_MAIN_CATEGORY_LIST_REQUEST':
            return {
                ...state,
                entityMainCategoryListloading: true,
            }
        case 'GET_CMS_WEBINAR_MAIN_CATEGORY_LIST_SUCCESS':
            return {
                ...state,
                entityMainCategoryListloading: false,
                entityMainCategoryList: action.payload
            }
        case 'GET_CMS_WEBINAR_MAIN_CATEGORY_LIST_FAILURE':
            return {
                ...state,
                loading: false,
                entityMainCategoryListError: action.payload
            }
        case 'CLEAR_CMS_WEBINAR_MAIN_CATEGORY_LIST':
            return {
                ...state,
                entityMainCategoryList: null
            }
        case 'GET_CMS_WEBINAR_SUB_CATEGORY_LIST_REQUEST':
            return {
                ...state,
                entitySubCategoryListloading: true,
            }
        case 'GET_CMS_WEBINAR_SUB_CATEGORY_LIST_SUCCESS':
            return {
                ...state,
                entitySubCategoryListloading: false,
                entitySubCategoryList: action.payload
            }
        case 'GET_CMS_WEBINAR_SUB_CATEGORY_LIST_FAILURE':
            return {
                ...state,
                loading: false,
                entitySubCategoryListError: action.payload
            }
        case 'CLEAR_CMS_WEBINAR_SUB_CATEGORY_LIST':
            return {
                ...state,
                entitySubCategoryList: null
            }
        case 'GET_CMS_WEBINAR_AGENDA_REQUEST':
            return {
                ...state,
                agendaDataloading: true,
            }
        case 'GET_CMS_WEBINAR_AGENDA_SUCCESS':
            return {
                ...state,
                agendaDataloading: false,
                agendaData: action.payload
            }
        case 'GET_CMS_WEBINAR_AGENDA_FAILURE':
            return {
                ...state,
                loading: false,
                agendaDataError: action.payload
            }
        case 'CLEAR_CMS_WEBINAR_AGENDA':
            return {
                ...state,
                agendaData: null
            }
        case 'GET_CMS_WEBINAR_FAQ_REQUEST':
            return {
                ...state,
                faqDataloading: true,
            }
        case 'GET_CMS_WEBINAR_FAQ_SUCCESS':
            return {
                ...state,
                faqDataloading: false,
                faqData: action.payload
            }
        case 'GET_CMS_WEBINAR_FAQ_FAILURE':
            return {
                ...state,
                loading: false,
                faqDataError: action.payload
            }
        case 'CLEAR_CMS_WEBINAR_FAQ':
            return {
                ...state,
                faqData: null
            }
        case 'GET_CMS_WEBINAR_KEYWORD_MAPPING_REQUEST':
            return {
                ...state,
                keywordMappingDataloading: true,
            }
        case 'GET_CMS_WEBINAR_KEYWORD_MAPPING_SUCCESS':
            return {
                ...state,
                keywordMappingDataloading: false,
                keywordMappingData: action.payload
            }
        case 'GET_CMS_WEBINAR_KEYWORD_MAPPING_FAILURE':
            return {
                ...state,
                loading: false,
                keywordMappingDataError: action.payload
            }
        case 'CLEAR_CMS_WEBINAR_KEYWORD_MAPPING':
            return {
                ...state,
                keywordMappingData: null
            }
        case 'PUT_CMS_WEBINAR_KEYWORD_MAPPING_SUCCESS':
            return {
                ...state,
                putWebinarKeywordMapping: action.payload
            }
        case 'PUT_CMS_WEBINAR_KEYWORD_MAPPING_FAILURE':
            return {
                ...state,
                putWebinarKeywordMappingError: action.payload
            }
        case 'CLEAR_PUT_CMS_WEBINAR_KEYWORD_MAPPING_RESPONSE':
            return {
                ...state,
                putWebinarKeywordMapping: null
            }
        case 'PUT_CMS_WEBINAR_AGENDA_SUCCESS':
            return {
                ...state,
                putWebinarAgenda: action.payload
            }
        case 'PUT_CMS_WEBINAR_AGENDA_FAILURE':
            return {
                ...state,
                putWebinarAgendaError: action.payload
            }
        case 'CLEAR_PUT_CMS_WEBINAR_AGENDA_RESPONSE':
            return {
                ...state,
                putWebinarAgenda: null
            }
        case 'PUT_CMS_WEBINAR_FAQ_SUCCESS':
            return {
                ...state,
                putWebinarFaq: action.payload
            }
        case 'PUT_CMS_WEBINAR_FAQ_FAILURE':
            return {
                ...state,
                putWebinarFaqError: action.payload
            }
        case 'CLEAR_PUT_CMS_WEBINAR_FAQ_RESPONSE':
            return {
                ...state,
                putWebinarFaq: null
            }

        default: return state
    }
}

export default WebinarReducer